import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUser, faPrint, faUserFriends, faBattery, faLightbulb, faBolt, faPassport, faBars, faSolarPanel } from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';
import firebaseApp from '../../firebase/credenciales';
import { getAuth, signOut } from 'firebase/auth';
const auth = getAuth(firebaseApp);

function Navbar({ user, onPrint }) {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <nav className="navbar">
            <div className="navbar-brand">CIVIC SUN ENGINEER</div>

            <div className="navbar-toggle" onClick={toggleMenu}>
                <FontAwesomeIcon icon={faBars} className="hamburger-icon" />
            </div>

            <ul className={`navbar-menu ${isOpen ? 'active' : ''}`}>
                {user?.rol === 'admin' &&
                    <>
                        <li><button onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faUser} /> <span>Administrador</span></button></li>
                        <li><button onClick={() => navigate('/solar-radiation')}><FontAwesomeIcon icon={faSolarPanel} /> <span>Radiación Solar</span></button></li>
                        {/* <li><button onClick={() => navigate('/admin/inversores')}><FontAwesomeIcon icon={faLightbulb} /> <span>Inversores</span></button></li>
                        <li><button onClick={() => navigate('/admin/controladores')}><FontAwesomeIcon icon={faBolt} /> <span>Controladores</span></button></li>
                        <li><button onClick={() => navigate('/admin/baterias')}><FontAwesomeIcon icon={faBattery} /> <span>Baterías</span></button></li>
                        <li><button onClick={() => navigate('/admin/estados')}><FontAwesomeIcon icon={faPassport} /> <span>Estados</span></button></li>
                        <li><button onClick={() => navigate('/register')}><FontAwesomeIcon icon={faUserFriends} /> <span>Usuarios</span></button></li>
                        */}
                    </>
                }
                {user?.rol === 'user' &&
                    <li><button onClick={() => navigate('/user')}><FontAwesomeIcon icon={faUser} /> <span>Perfil</span></button></li>
                }
                <li><button onClick={onPrint}><FontAwesomeIcon icon={faPrint} /> <span>Factura</span></button></li>
                <li><button onClick={() => signOut(auth)}><FontAwesomeIcon icon={faSignOutAlt} /> <span>Salir</span></button></li>
            </ul>
        </nav>
    );
}

export default Navbar;
